import { frontUrl } from "../helper/constants";

export interface SeoRecord {
  url: string;
  canonical: string;
  existing_title: string;
  recommended_title: string;
  meta_description: string;
  suggested_desc: string;
  suggested_h1: string;
   parsedSchema?: Record<string, any>;
}

// Define the array type
export const SeoData: SeoRecord[] = [
  {
    "url": "/contact-us",
    "canonical": `${frontUrl}contact-us`,
    "existing_title": "Gro - Truck Marketplace, Online Truck Booking, Load Booking, Fleet GPS Tracking",
    "recommended_title": "Contact Us | Support & Office Locations - Gro Digital Platforms.",
    "meta_description": "Get in touch with Gro Digital. 24/7 Customer Care: 1800-208-8800. Visit our local offices in Chennai, Kolkata, and others for fleet support and sales inquiries.",
    "suggested_desc": "Gro Digital Platform offers fleet management, logistics, and online truck booking solutions with real-time GPS tracking, roadside assistance, reliable transport support.",
    "suggested_h1": "Contact Gro Digital Platforms : Fleet Management & Truck Booking Support"
  
  },
  {
    "url": "/careers",
    "canonical": `${frontUrl}careers`,
    "existing_title": "gro Digital | Job Openings In Mumbai",
    "recommended_title": "Careers at Gro Digital | Build the Future of Indian Logistics & Fintech.",
    "meta_description": "Join the team transforming India's transportation. Explore opportunities in Sales, Tech, and Operations. Work with a joint venture of Ashok Leyland and Hinduja Leyland Finance.",
    "suggested_desc": "Explore career opportunities at Gro Digital, a leader in fleet management, and transport technology. Join our Mumbai team driving innovation in GPS tracking and digital trucking.",
    "suggested_h1": "Careers at Gro Digital Platforms : Join India’s Leading Fleet & Logistics Company",
     
  },
  {
    "url": "/about-us",
    "canonical": `${frontUrl}about-us`,
    "existing_title": "gro Digital Vehicle Fleet Management & Tracking Company",
    "recommended_title": "About Gro Digital | Pioneering Logistics Tech with Ashok Leyland & Hinduja Group.",
    "meta_description": "Gro Digital combines 70+ years of Hinduja Group's automotive heritage with cutting-edge logistics tech. We empower fleet owners and shippers with finance, loads, and service solutions.",
    "suggested_desc": "Gro Digital Platforms is a leading fleet management and logistics solutions company offering real-time GPS tracking, transport monitoring, and digital fleet operations across India.",
    "suggested_h1": "About Gro Digital - India's Smart Fleet Management & Logistics Partner",
    
  },
  {
    "url": "/",
    "canonical": `${frontUrl}`,
    "existing_title": "gro Digital Fleet & Logistics Management",
    "recommended_title": "Gro Digital | India's No. 1 Digital Trucking Platform",
    "meta_description": "India's 1st AI-integrated transportation platform offering end-to-end fleet and freight management solutions enabling faster load matching, insurance, real-time tracking, and higher operational efficiency for fleet owners nationwide.",
    "suggested_desc": "Gro Digital Platforms offers advanced fleet management, GPS tracking, logistics solutions for transporters and fleet owners. Manage trucks, loads, fuel, & routes with real-time insights.",
    "suggested_h1": "Fleet Management, GPS Tracking & Logistics Solutions by Gro Digital",
  
  },
  {
    "url": "/solutions",
    "canonical": `${frontUrl}solutions`,
    "existing_title": "gro Digital Fleet Management, Tracking System & Fleet Monitoring",
    "recommended_title": "Fleet Solutions | Guaranteed Loads, Fleet Tracking & Credit for Fleet Owners",
    "meta_description": "Discover end-to-end solutions for your transport business. From Gro Loads for return trips to Fuel Credit Cards and Fastag. Optimize your fleet operations with Gro's digital platform.",
    "suggested_desc": "",
    "suggested_h1": "Smart Freight Management & Digital Logistics Solutions by Gro Digital",
  
  },
  {
    "url": "/investors",
    "canonical": `${frontUrl}investors`,
    "existing_title": "gro Digital Investor",
    "recommended_title": "Investor Relations | Gro Digital Platforms Financial Reports & Governance",
    "meta_description": "Access financial disclosures, annual reports, and corporate governance policies of Gro Digital Platforms Limited. Stay updated on our growth as a leader in digital freight.",
    "suggested_desc": "Discover Gro's investor relations page for insights into India's fast-growing fleet management, logistics, and transportation ecosystem.",
    "suggested_h1": "Gro Digital Investor Relations - Driving Fleet & Logistics Growth",
  
  },
   {
    "url": "/gro-one-app",
    "canonical": `${frontUrl}gro-one-app`,
    "existing_title": "Gro One App",
    "recommended_title": "Gro One App | The All-in-One Super App for Fleet Owners & Truckers",
    "meta_description": "Download Gro One - India's 1st AI-powered transport app. Manage loads, track trucks, pay tolls, and access fuel credit in one place. Simplify your transport business on the go.",
    "suggested_desc": "Download Gro One - India's 1st AI-powered transport app. Manage loads, track trucks, pay tolls, and access fuel credit in one place. Simplify your transport business on the go.",
    "suggested_h1": "Gro One App - AI-Powered Trucking & Fleet Management Platform",
  
  },
    {
    "url": "/resources",
    "canonical": `${frontUrl}resources`,
    "existing_title": "Resource Centre",
    "recommended_title": "Resource Centre | Latest Blogs, News & Press Releases from Gro Digital",
    "meta_description": "Read the latest updates from Gro Digital, announcements, and innovations in the Indian transportation sector.",
    "suggested_desc": "Read the latest updates from Gro Digital, announcements, and innovations in the Indian transportation sector.",
    "suggested_h1": "Gro Digital Fleet & Logistics Resource Hub",
     "parsedSchema": 
      {
      "@context": "https://schema.org/", 
      "@type": "BreadcrumbList", 
      "itemListElement": [{
        "@type": "ListItem", 
        "position": 1, 
        "name": "Home",
        "item": "https://www.letsgro.co/"  
      },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "Resources",
        "item": "https://www.letsgro.co/resources"  
      }]
    }
  },
   {
    "url": "/privacy-policy",
    "canonical": `${frontUrl}privacy-policy`,
    "existing_title": "gro Digital Vehicle Fleet Management & Tracking Company",
    "recommended_title": "Privacy Policy | Data Security & User Protection at Gro Digital",
    "meta_description": "Learn how Gro Digital protects your personal and fleet data. Transparent policies on GPS tracking, credit assessment data, and ISO-certified cloud security standards.",
    "suggested_desc": "Learn how Gro Digital Platforms safeguards your data while offering fleet management, GPS tracking, and logistics services. Read our privacy policy for transparency and data protection.",
    "suggested_h1": "Gro Digital Privacy Policy - Data Protection for Fleet & Logistics Users",
  
  }
]